import { useEffect, useMemo } from 'react';
import { pluginSettingsVar } from '../../../apollo/store';
import { ProductType } from 'gql/__generated/vp-apollo';
import { useCheckAddressSuccessHandler } from 'hooks/useCheckAddressSuccessHandler';
import { useCheckAvailability } from 'hooks/useCheckAvailability';

export const useAddressSearchActions = () => {
    const { productType } = pluginSettingsVar();
    const { checkAvailability, availability, loading, error } = useCheckAvailability();
    const handleCheckAddressSuccess = useCheckAddressSuccessHandler();

    const goBackPath = useMemo(() => (productType === ProductType.Fttx ? '/' : undefined), [productType]);

    useEffect(() => {
        if (availability) {
            handleCheckAddressSuccess();
        }
    }, [availability, handleCheckAddressSuccess]);

    return {
        checkAvailability,
        goBackPath,
        loading,
        error,
    };
};
